<template>
  <footer>
    <div class="container wide">
      <div class="wrap">
        <div id="footer-menu">
          <div id="aboutus" class="aboutus">
            <nav>
              <ul>
                <li>
                  <a title="O firmie"
                     href="https://eon.pl/o-nas"
                     target="_blank"
                     id="footermenu_o-firmie">O firmie</a>
                </li>
                <li>
                  <a title="Dla Mediów"
                     href="https://eon.pl/dla-mediow/aktualnosci"
                     target="_blank"
                     id="footermenu_serwis-prasowy">Dla Mediów</a></li>
                <li>
                  <a title="Dla Partnerów"
                     href="https://eon.pl/zostan-partnerem"
                     target="_blank"
                     id="footermenu_dla-partnerow">Dla Partnerów</a>
                </li>
              </ul>
              <ul>
                <li>
                  <a title="Dla Dostawców"
                     href="https://eon.pl/dla-dostawcow/przetargi"
                     target="_blank"
                     id="footermenu_dla-dostawcow">Dla Dostawców</a>
                </li>
                <li>
                  <a title="Kariera"
                     href="https://eon.pl/kariera/poznaj-nas"
                     target="_blank"
                     id="footermenu_kariera">Kariera</a>
                </li>
                <li>
                  <a class="active"
                     title="Kontakt"
                     href="https://eon.pl/dla-domu/kontakt"
                     id="footermenu_kontakt"
                     target="_blank">Kontakt</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div id="footer-contact">
          <div>
            <p><strong>Zadzwoń</strong><br>Infolinia czynna od poniedziałku do piątku w&nbsp;godzinach&nbsp;8:00&nbsp;–&nbsp;18:00</p>
            <div>
              <p>
                <span itemprop="telephone">
                <a class="phone text" href="tel:022 821 46 46" title="22 821 46 46">22 821 46 46</a>
                </span>
              </p>
            </div>
          </div>
          <div>
            <p>
              <a id="layer-contact"
                 class="btn btn-yellow upp layer-btn_open"
                 href="mailto:informacja@eon.pl"
                 title="Napisz do nas">Napisz do nas</a>
            </p>
          </div>
        </div>

        <div id="footer-sc">
          <div class="social">
            <a class="ico i-social-footer fb" href="https://www.facebook.com/eonpolska" target="_blank" title="Facebook"></a>
            <a class="ico i-social-footer ig" href="https://www.instagram.com/eonpolska" target="_blank" title="Instagram"></a>
            <a class="ico i-social-footer linkedin" href="https://www.linkedin.com/mwlite/company/eonpolska" target="_blank" title="LinkedIn"></a>
          </div>

          <div class="copyright">
            <ul>
              <li>
                <a title="Regulamin" href="/files/eon/Regulamin-EON.pdf" target="_blank">Regulamin</a>
              </li>
              <li>
                <a title="Polityka prywatności"
                     href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf"
                     target="_blank">Polityka prywatności</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="data-administration">
        Administratorem danych osobowych jest Autopay S.A. ul. Powstańców Warszawy 6, 81-718 Sopot.
        Podanie danych osobowych jest dobrowolne, ale niezbędne do realizacji płatności. Podstawa prawna, cel,
        okres przetwarzania danych osobowych oraz uprawnienia przysługujące Użytkownikowi, a także inne ważne informacje
        dotyczące zasad przetwarzania danych osobowych są szczegółowo określone w <a
        href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank">Polityce
        prywatności Autopay S.A.</a></div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>
